export const ProductTypeEnum = {
  MODEL: 'MODEL',
  VARIATION: 'VARIATION',
  PART: 'PART',
};
